import * as React from 'react';
import '../Chat/app.scss';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {
	addDays,
	subDays,
	endOfDay,
	startOfDay,
	startOfMonth,
	endOfMonth,
	addMonths,
	startOfWeek,
	endOfWeek,
	startOfYear,
	endOfYear,
	addYears
} from 'date-fns';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { Container } from '../Container';
import { MessageContainer } from '../../Containers/MessageContainer';
import { AuthContext } from '../../contexts/AuthContext';
import * as Config from '../../config';
import * as LangConfig from '../../languages/languages';
import * as InterviewRef from '../../languages/langconfig';
import { DAClient } from '../../lib/DAClient';
import * as moment from 'moment';
import Image from 'react-bootstrap/Image';
import { DateRangePicker, DateRange, createStaticRanges } from 'react-date-range';
import { Bar, Pie } from 'react-chartjs-2';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tabs';
import AWS from 'aws-sdk';
import Axios from 'axios';
import analytics_ from '../../assets/images/analytics.svg';
import calanderarrow_ from '../../assets/images/boxarrow.svg';


const defineds = {
	startOfWeek: startOfWeek(new Date()),
	endOfWeek: endOfWeek(new Date()),
	startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
	endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
	startOfToday: startOfDay(new Date()),
	startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
	startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
	startOfLastNintyDay: startOfDay(addDays(new Date(), -90)),
	endOfToday: endOfDay(new Date()),
	startOfYesterday: startOfDay(addDays(new Date(), -1)),
	endOfYesterday: endOfDay(addDays(new Date(), -1)),
	startOfMonth: startOfMonth(new Date()),
	endOfMonth: endOfMonth(new Date()),
	startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
	endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
	startOfYear: startOfYear(new Date()),
	endOfYear: endOfYear(new Date()),
	startOflastYear: startOfYear(addYears(new Date(), -1)),
	endOflastYear: endOfYear(addYears(new Date(), -1))
};

const da = new DAClient();

interface IValueState {
	dateClick: any;
	rangeClick: any;
	dateRangePicker: any;
	dateRange: any;
	interviewStatus: any;
	completePerData: any;
	rangeSelected: any;
	allCompletedInterviews: any;
	allPendingInterviews: any;
	filteredInterviews: any;
	filteredCompletedInterviews: any;
	filteredPendingInterviews: any;
	allVerifiedUsers: any;
	allNotVerifiedUsers: any;
	filteredUsers: any;
	filteredVerifiedUsers: any;
	filteredNotVerifiedUsers: any;
}

interface IUsersState {
	allVerifiedUsers: any;
	allNotVerifiedUsers: any;
	filteredUsers: any;
	filteredUsersAll: any;
	filteredVerifiedUsers: any;
	filteredNotVerifiedUsers: any;
}

const endDateVal = new Date();
const startDateVal = new Date().setMonth(endDateVal.getMonth() - 1);
const startDateNew = new Date(startDateVal);

export const AdminDashboard: React.FC = () => {
	const auth = React.useContext(AuthContext);
	const [users, setUsers] = React.useState([]);
	const [alltime, setAlltime] = React.useState(false);
	const [chartRef, createChartRef] = React.useState(null);
	const [translations, setTranslations] = React.useState(auth['user']['attributes'].locale ? LangConfig.languages[auth['user']['attributes'].locale]['translations'] : LangConfig.languages['en']['translations']);
	const [selectedLng, setselectedLng] = React.useState(auth['user']['attributes'].locale ? auth['user']['attributes'].locale : 'en');
	const [usersWithoutVoice, setUsersWithoutVoice] = React.useState(0)
	const [usersWithVoice, setUsersWithVoice] = React.useState(0)
	const [allInterviews, setAllInterviews] = React.useState([]);
	const [availInterviews, setAvailInterviews] = React.useState([]);
	const [corp, setCOrP] = React.useState([]);
	const [selectedInterview, setSelectedInterview] = React.useState('all');
	const [startdate, setStartdate] = React.useState(null);
	const [enddate, setEnddate] = React.useState(null);

	const [stateUsers, setStateUsers] = React.useState<IUsersState>({
		allVerifiedUsers: 0,
		allNotVerifiedUsers: 0,
		filteredUsers: 0,
		filteredUsersAll: [],
		filteredVerifiedUsers: 0,
		filteredNotVerifiedUsers: 0,
	});

	const sideBarOptions = () => {
		let mom: any = moment;
		const customDateObjects = [
			{
				label: 'Today',
				range: () => ({
					startDate: defineds.startOfToday,
					endDate: defineds.endOfToday
				})
			},
			{
				label: 'This Week',
				range: () => ({
					startDate: defineds.startOfWeek,
					endDate: defineds.endOfWeek
				})
			},
			{
				label: 'Last Week',
				range: () => ({
					startDate: defineds.startOfLastWeek,
					endDate: defineds.endOfLastWeek
				})
			},
			{
				label: 'This Month',
				range: () => ({
					startDate: defineds.startOfMonth,
					endDate: defineds.endOfMonth
				})
			},
			{
				label: 'Last Month',
				range: () => ({
					startDate: defineds.startOfLastMonth,
					endDate: defineds.endOfLastMonth
				})
			},
			{
				label: 'This Year',
				range: () => ({
					startDate: defineds.startOfYear,
					endDate: defineds.endOfYear
				})
			},
			{
				label: 'Last Year',
				range: () => ({
					startDate: defineds.startOflastYear,
					endDate: defineds.endOflastYear
				})
			},
			{
				label: 'All Time',
				range: () => ({
					startDate: mom('01-03-2021', 'DD-MM-YYYY').toDate(),
					endDate: mom().toDate()
				})
			}
		];

		return customDateObjects;
	};

	const sideBar = sideBarOptions();

	const staticRanges = [
		...createStaticRanges(sideBar)
	];

	const [values, setValues] = React.useState<IValueState>({
		dateClick: 'close',
		rangeClick: '',
		rangeSelected: '',
		allCompletedInterviews: 0,
		allPendingInterviews: 0,
		filteredInterviews: 0,
		filteredCompletedInterviews: 0,
		filteredPendingInterviews: 0,
		allVerifiedUsers: 0,
		allNotVerifiedUsers: 0,
		filteredUsers: 0,
		filteredVerifiedUsers: 0,
		filteredNotVerifiedUsers: 0,

		dateRangePicker: {
			selection: {
				startDate: startDateNew,
				endDate: endDateVal,
				key: 'selection',
			},
		},
		dateRange: {
			selection: {
				startDate: startDateNew,
				endDate: endDateVal,
				key: 'selection',
			},
		},
		interviewStatus: {
			labels: [
				translations.Completed_Interviews,
				translations.Pending_Interviews
			],
			datasets: [{
				data: [0, 0],
				borderRadius: 20,
				backgroundColor: [
					'#16ABFF',
					'#FF8A58'
				],
				hoverBackgroundColor: [
					'#16ABFF',
					'#FF8A58'
				]
			}]
		},
		completePerData: {
			type: 'bar',
			labels: [],
			datasets: [
				{
					label: translations.Completed_Interviews,
					backgroundColor: '#16ABFF',
					borderColor: '#16ABFF',
					borderTopLeftRadius: 20,
					borderTopRightRadius: 20,
					borderWidth: 1,
					hoverBackgroundColor: '#16ABFF',
					hoverBorderColor: '#16ABFF',
					data: []
				},
				{
					label: translations.Pending_Interviews,
					backgroundColor: '#FF8A58',
					borderColor: '#FF8A58',
					borderTopLeftRadius: 20,
					borderTopRightRadius: 20,
					borderWidth: 1,
					hoverBackgroundColor: '#FF8A58',
					hoverBorderColor: '#FF8A58',
					data: []
				}
			]
		}
	});

	const getUsers = async (applicationName) => {
		try {
			let allUsers = [];
			let more = true;
			let paginationToken = '';

			AWS.config.update(Config.AWSConfigExport);
			const cognito = new AWS.CognitoIdentityServiceProvider();

			let app_pool_Id: any;
			if (applicationName == 'ATJ') {
				app_pool_Id = Config.AWS_userPoolId;
			} else {
				app_pool_Id = Config.AWS_LDV_userPoolId;
			}

			let params: any;
			while (more) {
				if (paginationToken !== '') {
					params = {
						UserPoolId: app_pool_Id,
						PaginationToken: paginationToken
					}
				} else {
					params = {
						UserPoolId: app_pool_Id
					}
				}
				const rawUsers = await cognito.listUsers(params).promise();

				rawUsers.Users.map(function (result, index) {
					let verfied = result.Attributes.find((item, key) => { return (item.Name == "email_verified") });
					allUsers.push({
						"Email": result.Attributes.find((item, key) => { return (item.Name == "email") }).Value,
						"Username": result.Username,
						"Status": result.UserStatus,
						"Email Verified": verfied ? verfied.Value : null,
						"Created": new Date(result.UserCreateDate).toISOString().split('T')[0],
						"createdDate": result.UserCreateDate,
						"Last Modified": new Date(result.UserLastModifiedDate).toISOString().split('T')[0]
					});
				});

				if (rawUsers.PaginationToken) {
					paginationToken = rawUsers.PaginationToken;
				} else {
					more = false;
				}

			}
			setUsers(allUsers);

			// filtered total, verified and notverified users
			filterUsers(allUsers, startDateNew, endDateVal);
		} catch (e) {
			// console.log(e);
		}
	};

	const submittedInterviews = async (AvailableInterviews) => {
		let sess = await Axios.post(Config.API_BASE_URL + 'getAllDocAssembleUserData', {
			host: Config.appHost
		});

		let availTitlesArr = AvailableInterviews.map(interview => interview.filename);
		// filter the DB for available interviews submissions only
		sess.data.DocAssembleData = sess.data.DocAssembleData.filter((interview) => {
			return availTitlesArr.indexOf(interview.i) != -1;
		});

		// sort in descending order by interview title
		sess.data.DocAssembleData.sort((a, b) => (a.title > b.title) ? -1 : ((b.title > a.title) ? 1 : 0));
		setAllInterviews(sess.data.DocAssembleData);

		// check the frequency of interview submission
		let titlesArr = sess.data.DocAssembleData.map(interview => interview.title);
		let titlesArr1 = availTitlesArr.filter((interview) => {
			return titlesArr.indexOf(interview.title) != -1;
		});
		titlesArr = titlesArr.concat(titlesArr1);
		let frequencyResult = interviewFrequency(titlesArr);
		return { frequencyResult: frequencyResult, allInt: sess.data.DocAssembleData };
	}

	const listAvailInterviews = async () => {
		let AvailableInterviews: any = await da.listInterviews();
		AvailableInterviews = AvailableInterviews.filter((e) => {
			return e.metadata['required privileges'].indexOf(Config.appHost) != -1;
		});
		AvailableInterviews.sort((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
		let AllAvailableInterviews = AvailableInterviews;
		AvailableInterviews = AvailableInterviews.map(e => {
			if (InterviewRef.languagesconfigs[e.filename]) {
				let myArray = AvailableInterviews.filter(el => el.filename == InterviewRef.languagesconfigs[e.filename][selectedLng]);
				return myArray[0];
			} else {
				return e;
			}

		});
		let { frequencyResult, allInt } = await submittedInterviews(AllAvailableInterviews);
		frequencyResult.sort((a, b) => (a.count > b.count) ? -1 : ((b.count > a.count) ? 1 : 0));
		let topSortedTitles = frequencyResult.map(r => r.title);

		let result = [];
		for (let title of topSortedTitles) {
			var found = false;
			AvailableInterviews = AvailableInterviews.filter((interview) => {
				if (!found && interview['title'] == title) {
					result.push(interview);
					found = true;
					return false;
				} else
					return true;
			})
		}
		AvailableInterviews = result;
		setAvailInterviews(AvailableInterviews);
		// filtered interviews, filtered completed and pending interviews
		filterInterviews(allInt, startDateNew, endDateVal, result, selectedInterview, alltime)
	}

	const interviewFrequency = (interviewsTitleArr) => {
		// check frequency of an interview in submission and sort the available interviews acc. to it
		var frequency = [], prev;
		interviewsTitleArr.sort();

		for (var i = 0; i < interviewsTitleArr.length; i++) {
			if (interviewsTitleArr[i] !== prev) {
				frequency.push({ title: interviewsTitleArr[i], count: 1 });
			} else {
				frequency[frequency.length - 1].count++;
			}
			prev = interviewsTitleArr[i];
		}
		return frequency;
	}


	const handleRangeChange = (which, payload) => {
		values[which].selection.startDate = payload.selection.startDate;
		values[which].selection.endDate = payload.selection.endDate;

		if (values.rangeSelected == '') {
			setValues({ ...values, [which]: { ...values[which] }, rangeSelected: 'start' });
		} else {
			setValues({ ...values, [which]: { ...values[which] } });
		}

		if ((which == 'dateRangePicker' && ((values.rangeSelected == 'start' && values.rangeClick == '') || values.rangeClick == 'staticRanges' /*|| values.rangeClick == 'inputRanges'*/)) || (values.rangeSelected == 'start' && values.rangeClick == '')) {

			setStartdate(payload.selection.startDate);
			setEnddate(payload.selection.endDate);
			// filtered interviews, filtered completed and pending interviews
			filterInterviews(allInterviews, payload.selection.startDate, payload.selection.endDate, availInterviews, selectedInterview, alltime);

			// filtered total, verified and notverified users
			filterUsers(users, payload.selection.startDate, payload.selection.endDate);
		}
	}

	const handlePreviewChange = (value) => {
		if (value != undefined) {
			if (value.startDate != undefined) {
				setValues({ ...values, rangeClick: 'staticRanges' });
			} /*else {
		    setValues({...values ,  rangeClick: '' });
		  }*/
		} /*else {
		  setValues({...values ,  rangeClick: 'inputRanges' });
		}*/
	}
	const svgGenerate = () => {
		var useTag = '<svg id="SvgjsSvg1974" width="882" height="280" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="" class="apexcharts-svg" xmlns:data="ApexChartsNS" transform="translate(0, 0)" style="background: transparent;width: 100%;position: absolute;top: -60px;left: 0;"><g id="SvgjsG1976" class="apexcharts-inner apexcharts-graphical" transform="translate(0, 125)"><defs id="SvgjsDefs1975"><clipPath id="gridRectMaskdpgoe8hl"><rect id="SvgjsRect1980" width="884" height="121" x="-1" y="-1" rx="0" ry="0" fill="#ffffff" opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"></rect></clipPath><clipPath id="gridRectMarkerMaskdpgoe8hl"><rect id="SvgjsRect1981" width="884" height="121" x="-1" y="-1" rx="0" ry="0" fill="#ffffff" opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"></rect></clipPath><linearGradient id="SvgjsLinearGradient1987" x1="0" y1="0" x2="0" y2="1"><stop id="SvgjsStop1988" stop-opacity="0.4" stop-color="rgba(255,255,255,0.4)" offset="0.45"></stop><stop id="SvgjsStop1989" stop-opacity="0.05" stop-color="rgba(255,255,255,0.05)" offset="1"></stop><stop id="SvgjsStop1990" stop-opacity="0.05" stop-color="rgba(255,255,255,0.05)" offset="1"></stop></linearGradient></defs><line id="SvgjsLine1979" x1="881.5000000000001" y1="0" x2="881.5000000000001" y2="119" stroke="#b6b6b6" stroke-dasharray="3" class="apexcharts-xcrosshairs" x="881.5000000000001" y="0" width="1" height="119" fill="#b1b9c4" filter="none" fill-opacity="0.9" stroke-width="1"></line><g id="SvgjsG1993" class="apexcharts-xaxis" transform="translate(0, 0)"><g id="SvgjsG1994" class="apexcharts-xaxis-texts-g" transform="translate(0, -4)"></g></g><g id="SvgjsG1997" class="apexcharts-grid"><line id="SvgjsLine1999" x1="0" y1="119" x2="882" y2="119" stroke="transparent" stroke-dasharray="0"></line><line id="SvgjsLine1998" x1="0" y1="1" x2="0" y2="119" stroke="transparent" stroke-dasharray="0"></line></g><g id="SvgjsG1983" class="apexcharts-area-series apexcharts-plot-series"><g id="SvgjsG1984" class="apexcharts-series" seriesname="Sales" data:longestseries="true" rel="1" data:realindex="0"><path id="apexcharts-area-0" d="M 0 119L 0 64.9090909090909C 34.300000000000004 64.9090909090909 63.70000000000001 41.72727272727272 98.00000000000001 41.72727272727272C 132.3 41.72727272727272 161.70000000000002 49.45454545454544 196.00000000000003 49.45454545454544C 230.3 49.45454545454544 259.7 18.545454545454533 294 18.545454545454533C 328.3 18.545454545454533 357.70000000000005 45.59090909090908 392.00000000000006 45.59090909090908C 426.30000000000007 45.59090909090908 455.70000000000005 3.0909090909090793 490.00000000000006 3.0909090909090793C 524.3000000000001 3.0909090909090793 553.7 45.59090909090908 588 45.59090909090908C 622.3 45.59090909090908 651.7 18.545454545454533 686 18.545454545454533C 720.3000000000001 18.545454545454533 749.7 49.45454545454544 784.0000000000001 49.45454545454544C 818.3000000000001 49.45454545454544 847.7000000000002 41.72727272727272 882.0000000000001 41.72727272727272C 882.0000000000001 41.72727272727272 882.0000000000001 41.72727272727272 882.0000000000001 119M 882.0000000000001 41.72727272727272z" fill="url(#SvgjsLinearGradient1987)" fill-opacity="1" stroke-opacity="1" stroke-linecap="butt" stroke-width="0" stroke-dasharray="0" class="apexcharts-area" index="0" clip-path="url(#gridRectMaskdpgoe8hl)" pathto="M 0 119L 0 64.9090909090909C 34.300000000000004 64.9090909090909 63.70000000000001 41.72727272727272 98.00000000000001 41.72727272727272C 132.3 41.72727272727272 161.70000000000002 49.45454545454544 196.00000000000003 49.45454545454544C 230.3 49.45454545454544 259.7 18.545454545454533 294 18.545454545454533C 328.3 18.545454545454533 357.70000000000005 45.59090909090908 392.00000000000006 45.59090909090908C 426.30000000000007 45.59090909090908 455.70000000000005 3.0909090909090793 490.00000000000006 3.0909090909090793C 524.3000000000001 3.0909090909090793 553.7 45.59090909090908 588 45.59090909090908C 622.3 45.59090909090908 651.7 18.545454545454533 686 18.545454545454533C 720.3000000000001 18.545454545454533 749.7 49.45454545454544 784.0000000000001 49.45454545454544C 818.3000000000001 49.45454545454544 847.7000000000002 41.72727272727272 882.0000000000001 41.72727272727272C 882.0000000000001 41.72727272727272 882.0000000000001 41.72727272727272 882.0000000000001 119M 882.0000000000001 41.72727272727272z" pathfrom="M -1 119L -1 119L 98.00000000000001 119L 196.00000000000003 119L 294 119L 392.00000000000006 119L 490.00000000000006 119L 588 119L 686 119L 784.0000000000001 119L 882.0000000000001 119"></path><path id="apexcharts-area-0" d="M 0 64.9090909090909C 34.300000000000004 64.9090909090909 63.70000000000001 41.72727272727272 98.00000000000001 41.72727272727272C 132.3 41.72727272727272 161.70000000000002 49.45454545454544 196.00000000000003 49.45454545454544C 230.3 49.45454545454544 259.7 18.545454545454533 294 18.545454545454533C 328.3 18.545454545454533 357.70000000000005 45.59090909090908 392.00000000000006 45.59090909090908C 426.30000000000007 45.59090909090908 455.70000000000005 3.0909090909090793 490.00000000000006 3.0909090909090793C 524.3000000000001 3.0909090909090793 553.7 45.59090909090908 588 45.59090909090908C 622.3 45.59090909090908 651.7 18.545454545454533 686 18.545454545454533C 720.3000000000001 18.545454545454533 749.7 49.45454545454544 784.0000000000001 49.45454545454544C 818.3000000000001 49.45454545454544 847.7000000000002 41.72727272727272 882.0000000000001 41.72727272727272" fill="none" fill-opacity="1" stroke="#ffffff" stroke-opacity="1" stroke-linecap="butt" stroke-width="2" stroke-dasharray="0" class="apexcharts-area" index="0" clip-path="url(#gridRectMaskdpgoe8hl)" pathto="M 0 64.9090909090909C 34.300000000000004 64.9090909090909 63.70000000000001 41.72727272727272 98.00000000000001 41.72727272727272C 132.3 41.72727272727272 161.70000000000002 49.45454545454544 196.00000000000003 49.45454545454544C 230.3 49.45454545454544 259.7 18.545454545454533 294 18.545454545454533C 328.3 18.545454545454533 357.70000000000005 45.59090909090908 392.00000000000006 45.59090909090908C 426.30000000000007 45.59090909090908 455.70000000000005 3.0909090909090793 490.00000000000006 3.0909090909090793C 524.3000000000001 3.0909090909090793 553.7 45.59090909090908 588 45.59090909090908C 622.3 45.59090909090908 651.7 18.545454545454533 686 18.545454545454533C 720.3000000000001 18.545454545454533 749.7 49.45454545454544 784.0000000000001 49.45454545454544C 818.3000000000001 49.45454545454544 847.7000000000002 41.72727272727272 882.0000000000001 41.72727272727272" pathfrom="M -1 119L -1 119L 98.00000000000001 119L 196.00000000000003 119L 294 119L 392.00000000000006 119L 490.00000000000006 119L 588 119L 686 119L 784.0000000000001 119L 882.0000000000001 119"></path><g id="SvgjsG1985" class="apexcharts-series-markers-wrap"><g class="apexcharts-series-markers"><circle id="SvgjsCircle2005" r="0" cx="882.0000000000001" cy="41.72727272727272" class="apexcharts-marker wwrn9rdj2 no-pointer-events" stroke="#ffffff" fill="#ffffff" fill-opacity="1" stroke-width="2" stroke-opacity="0.9" default-marker-size="0"></circle></g></g><g id="SvgjsG1986" class="apexcharts-datalabels"></g></g></g><line id="SvgjsLine2000" x1="0" y1="0" x2="882" y2="0" stroke="#b6b6b6" stroke-dasharray="0" stroke-width="1" class="apexcharts-ycrosshairs"></line><line id="SvgjsLine2001" x1="0" y1="0" x2="882" y2="0" stroke-dasharray="0" stroke-width="0" class="apexcharts-ycrosshairs-hidden"></line><g id="SvgjsG2002" class="apexcharts-yaxis-annotations"></g><g id="SvgjsG2003" class="apexcharts-xaxis-annotations"></g><g id="SvgjsG2004" class="apexcharts-point-annotations"></g></g><rect id="SvgjsRect1978" width="0" height="0" x="0" y="0" rx="0" ry="0" fill="#fefefe" opacity="1" stroke-width="0" stroke="none" stroke-dasharray="0"></rect><g id="SvgjsG1995" class="apexcharts-yaxis" rel="0" transform="translate(-21, 0)"><g id="SvgjsG1996" class="apexcharts-yaxis-texts-g"></g></g></svg>';
		return <svg dangerouslySetInnerHTML={{ __html: useTag }} />;
	}

	const formatDateDisplay = (date, defaultText = "") => {
		if (!date) return defaultText;
		let mom: any = moment;
		return mom(date).format("D MMM, YYYY");
	}

	const dateOpen = () => {
		if (values.dateClick == 'close') {
			setValues({ ...values, dateClick: '' });
		} else {
			setValues({ ...values, dateClick: 'close' });
		}
	}

	const filterUsers = async (allUsers, startDate, endDate) => {
		// filtered total, verified and notverified users
		let filteredUsers = allUsers.filter((uData) => {
			return uData.Created >= new Date(startDate).toISOString().split('T')[0] && uData.Created <= new Date(endDate).toISOString().split('T')[0];
		});
		let filteredVerifiedUsers = filteredUsers.filter((uData) => {
			return uData.Status == "CONFIRMED";
		});

		// total verified and notverified users
		let allVerifiedUsers = allUsers.filter((uData) => {
			return uData.Status == "CONFIRMED";
		});

		setStateUsers({ ...stateUsers, filteredUsers: filteredUsers.length, filteredVerifiedUsers: filteredVerifiedUsers.length, filteredNotVerifiedUsers: (filteredUsers.length - filteredVerifiedUsers.length), allVerifiedUsers: allVerifiedUsers.length, allNotVerifiedUsers: (allUsers.length - allVerifiedUsers.length), filteredUsersAll: filteredUsers });
	}

	const selectInterview = (filename) => {
		setSelectedInterview(filename);
		filterInterviews(allInterviews, startdate ? startdate : startDateNew, enddate ? enddate : endDateVal, availInterviews, filename, alltime);
	}

	const findMinDate = (array) => {
		let min = new Date().toISOString();
		array.forEach(element => {
			if (element < min)
				min = element
		});
		return min;
	}

	const filterInterviews = async (allInterviews, startDate, endDate, avail, fname, begin) => {
		// filtered interviews, filtered completed and pending interviews
		let filteredInterviews = allInterviews;
		let enddate = new Date();
		let tempDate = new Date(findMinDate(filteredInterviews.map(el => el.createdAt)));
		let startDate1 = new Date((tempDate.getMonth() + 1) + '-' + tempDate.getDate() + '-' + tempDate.getFullYear());
		if (!begin) {
			filteredInterviews = allInterviews.filter((iData) => {
				return iData.createdAt >= new Date(startDate).toISOString() && iData.createdAt <= new Date(endDate).toISOString();
			});
			startDate1 = new Date((startDate.getMonth() + 1) + '-' + startDate.getDate() + '-' + startDate.getFullYear());
			enddate = endDate;
		}
		if (fname !== 'all') {
			avail = availInterviews.filter(el => el.filename == fname);
			filteredInterviews = allInterviews.filter((iData) => {
				return checkInLangObj(fname, iData.i)
			})
		}
		let filteredCompleted = filteredInterviews.filter((iData) => {
			return iData.fileNumber && iData.fileNumber != 0;
		});
		let corps = [];
		values.interviewStatus.datasets[0].data[0] = filteredCompleted.length;
		values.interviewStatus.datasets[0].data[1] = (filteredInterviews.length - filteredCompleted.length);
		values.interviewStatus.datasets = [...values.interviewStatus.datasets];

		// % of completion chart
		let datasets = [], fileNames = [];
		avail.forEach((el) => {
			datasets.push({
				label: el.title + '.',
				stack: 'Completed',
				backgroundColor: '#16ABFF',
				borderColor: '#16ABFF',
				borderTopLeftRadius: 20,
				borderTopRightRadius: 20,
				borderWidth: 1,
				hoverBackgroundColor: '#16ABFF',
				hoverBorderColor: '#16ABFF',
				data: []
			});
			fileNames.push(el.filename);
			datasets.push({
				label: el.title,
				stack: 'Pending',
				backgroundColor: '#FF8A58',
				borderColor: '#FF8A58',
				borderTopLeftRadius: 20,
				borderTopRightRadius: 20,
				borderWidth: 1,
				hoverBackgroundColor: '#FF8A58',
				hoverBorderColor: '#FF8A58',
				data: []
			});
			fileNames.push(el.filename);
		});
		values.completePerData.datasets = datasets;
		values.completePerData.labels = [];
		values.completePerData.dates = [];

		let totalInterviewCountDateWise: any = filteredInterviews;
		let tempInd = 0;
		while (startDate1 <= enddate) {
			tempInd += 1;
			values.completePerData.dates.push(JSON.stringify((startDate1.getMonth() + 1) + '-' + startDate1.getDate() + '-' + startDate1.getFullYear()));
			values.completePerData.labels.push(tempInd);
			startDate1.setDate(startDate1.getDate() + 1);
			let completeOrPeningDateWise: any = [];
			totalInterviewCountDateWise = totalInterviewCountDateWise.filter((iData) => {
				if (iData.createdAt.split('T')[0] == new Date(startDate1).toISOString().split('T')[0]) {
					if (iData.fileNumber && iData.fileNumber != 0) {
						completeOrPeningDateWise.push({ interview: iData, status: true });
					} else {
						completeOrPeningDateWise.push({ interview: iData, status: false });
					}
					return false;
				} else {
					return true;
				}
			});

			values.completePerData.datasets.map((set, indi) => {
				if (set.label.includes('.')) {
					set.data.push(completeOrPeningDateWise.filter(chi => chi.status && checkInLangObj(fileNames[indi], chi.interview.i)).length);
				} else {
					set.data.push(completeOrPeningDateWise.filter(chi => !chi.status && checkInLangObj(fileNames[indi], chi.interview.i)).length);
				}
				return set;
			})

			corps.push(completeOrPeningDateWise);
		}
		values.completePerData.labels = [...values.completePerData.labels];
		values.completePerData.datasets = [...values.completePerData.datasets];
		setCOrP(corps);

		// total interviews, total completed and pending interviews
		let completed = allInterviews.filter((iData) => {
			return iData.fileNumber && iData.fileNumber != 0;
		});

		setValues({ ...values, dateClick: 'close', rangeSelected: '', rangeClick: '', filteredInterviews: filteredInterviews.length, filteredCompletedInterviews: filteredCompleted.length, filteredPendingInterviews: (filteredInterviews.length - filteredCompleted.length), allCompletedInterviews: completed.length, allPendingInterviews: (allInterviews.length - completed.length) });
	}


	const checkInLangObj = (filename, i) => {
		if (InterviewRef.languagesconfigs[filename]) {
			let filtered = Object.keys(InterviewRef.languagesconfigs[filename]).filter(el => {
				if (InterviewRef.languagesconfigs[filename][el] == i) {
					return true;
				}
				return false;
			})
			if (filtered.length > 0) {
				return true
			}
			return false
		}
		return false;
	}


	const exportData = async () => {
		let fields = ['Date'], fileNames = [''];
		availInterviews.forEach((el) => {
			if (selectedInterview == 'all') {
				fields.push(el.title + ' (Completed)');
				fileNames.push(el.filename);
				fields.push(el.title + ' (Pending)');
				fileNames.push(el.filename);
			} else {
				if (selectedInterview == el.filename) {
					fields.push(el.title + ' (Completed)');
					fileNames.push(el.filename);
					fields.push(el.title + ' (Pending)');
					fileNames.push(el.filename);
				}
			}
		});
		let mom: any = moment;
		let alls = values.completePerData.dates.map((ques, qi) => {
			let obj = {};
			obj['Date'] = ques;
			fields.forEach((el, indi) => {
				if (el !== 'Date') {
					if (el.includes('Completed')) {
						obj[el] = corp[qi].filter(co => co.status && checkInLangObj(fileNames[indi], co.interview.i)).length;
					} else {
						obj[el] = corp[qi].filter(co => !co.status && checkInLangObj(fileNames[indi], co.interview.i)).length;
					}
				}
			})
			return obj;
		})

		let lastIndexData = {};
		lastIndexData['Date'] = 'Total';
		fields.forEach((el, findex) => {
			if (el !== 'Date') {
				let total = 0;
				alls.forEach(currentValue => {
					total += currentValue[el];
				});
				lastIndexData[el] = total;
			}
		})

		alls.push(lastIndexData);


		let firstIndexData = {};
		firstIndexData['Date'] = null;
		fields.forEach((el, findex) => {
			if (el !== 'Date') {
				if (el.includes('Completed')) {
					firstIndexData[el] = 'Completed';
				} else {
					firstIndexData[el] = 'Pending';
				}
			}
		})
		alls.unshift(firstIndexData);

		let data: any = await Axios.post(Config.API_BASE_URL + 'export', {
			fields: fields,
			data: alls,
			name: 'dashboard-data'
		});
		return window.open(Config.API_BASE_URL + 'download/' + data.data.filename);
	}


	const getAllData = async () => {
		let sess = await Axios.post(Config.API_BASE_URL + 'getAllDocAssembleUserData', {
			host: Config.appHost
		});
		let num = 0;
		let numVoice = 0;
		sess.data.DocAssembleData.forEach((interview) => {
			if (interview.questionAns) {
				interview.questionAns.filter(question => {
					if (question.variable) {
						Object.keys(question.variable).forEach((key) => {
							if (key == 'voice_or_text') {
								if (question.variable['voice_or_text'] == 'Continue with text' || question.variable['voice_or_text'] == 'Continuar con el texto') {
									num += 1;
								} else if (question.variable['voice_or_text'] == 'Continue with voice' || question.variable['voice_or_text'] == 'Continuar con voz') {
									numVoice += 1;
								}
							}
						});
					}
				});
			}
		});
		setUsersWithVoice(numVoice);
		setUsersWithoutVoice(num);
	}

	React.useEffect(() => {
		getAllData();
		getUsers('ATJ');
		// submittedInterviews();
		listAvailInterviews();
	}, [auth]);

	return (
		<MessageContainer
			render={({ messages, setMessages, resetSession, useOldSession }) => (
				<>
					<div>
						<Header resetSession={resetSession} />
						<div className="app-main">
							<div className="app-main-inner adminDashboardMob">
								<Container
									style={{
										paddingTop: 30,
										paddingBottom: 30,
									}}
								>
									<div className="fillColor">
										<section className="position-relative bg">
											<div className="admindashboard"></div>
										</section>
										<section className="adminContent my-5">
											<div className="row mb-4">
												<div className="col-md-6 col-sm-12 col-12 d-flex flex-wrap align-items-center p-0">
													<h1 className="h3 pb-0 mb-0 admin"><span>{translations.Welcome}</span> {translations.Admin}</h1>
												</div>
												<div className="col-md-6 col-sm-12 col-12 pr-0 pl-sm-3 p-0 d-flex flex-wrap justify-content-md-end justify-content-start align-items-center dateFilter hide-mob">

													<div className="filter d-md-block d-sm-none d-none">
														<div className="filter_input input d-flex flex-wrap align-items-center">
															<a><input type='checkbox' checked={alltime} onChange={(e) => {
																setAlltime(e.target.checked);
																filterInterviews(allInterviews, startdate ? startdate : startDateNew, enddate ? enddate : endDateVal, availInterviews, selectedInterview, e.target.checked)
															}} /> <span>All Time Data</span></a>
															&nbsp;<span>{!alltime ? '|' : null}</span>&nbsp;
															{!alltime ? <a onClick={dateOpen}>
																<span>{translations.from}</span><input
																	type="text" className="form-control d-inline"
																	value={formatDateDisplay(values.dateRangePicker.selection.startDate)} onClick={dateOpen}
																/>
																<span>{translations.to}</span><input
																	type="text" className="form-control d-inline"
																	value={formatDateDisplay(values.dateRangePicker.selection.endDate)} onClick={dateOpen}
																/>
															</a> : null}
														</div>
														<div className="showcalander">
															<DateRangePicker
																onChange={handleRangeChange.bind(this, 'dateRangePicker')}
																showSelectionPreview={true}
																moveRangeOnFirstSelection={true}
																className={'PreviewArea ' + values.dateClick}
																months={1}
																ranges={[values.dateRangePicker.selection]}
																direction="horizontal"
																onPreviewChange={(value) => handlePreviewChange(value)}
																inputRanges={[]}
																staticRanges={staticRanges}
															/>
														</div>
													</div>
													<div className="filter d-md-none d-sm-block d-block my-sm-0 my-2">
														<div className="input d-flex flex-wrap align-items-center">

															<input
																type="text" className="form-control rounded"
																readOnly
																value={formatDateDisplay(values.dateRange.selection.startDate)} onClick={dateOpen}
															/>
															<input
																type="text" className="form-control rounded"
																readOnly
																value={formatDateDisplay(values.dateRange.selection.endDate, 'Continuous')} onClick={dateOpen}
															/>
															<a onClick={dateOpen} > calander</a>
														</div>
														<div className="showcalander">
															<DateRange
																onChange={handleRangeChange.bind(this, 'dateRange')}
																moveRangeOnFirstSelection={false}
																ranges={[values.dateRange.selection]}
																className={'PreviewArea ' + values.dateClick}
															/>
														</div>
													</div>
												</div>
											</div>
											<div className="row mt-lg-0 mb-32">
												<div className="leftSide pr-xl-0 pr-3 mt-lg-0 mt-md-0 mt-0 mt-sm-4">
													<div className="box interviewBg w-100 mb-32">
														<div className="info">
															<div className="row mb-46">
																<div className="col-12 p-0">
																	<h1> {users.length} </h1>
																	{translations.Total_Users}
																</div>
															</div>
															<div className="row usersStatus">
																<div className="col-md-6 col-sm-6 col-6 p-0">
																	<h4 className="pb-0"> {stateUsers.allVerifiedUsers} </h4>
																	{translations.Verified}
																</div>
																<div className="col-md-6 col-sm-6 col-6 p-0">
																	<h4 className="pb-0 unverified">  {stateUsers.allNotVerifiedUsers} </h4>
																	{translations.Unverified}
																</div>
															</div>
														</div>
														<div className="infoGraph">
															<h1> {stateUsers.filteredUsers} </h1>
															{translations.New_users}
															<svg width="205" height="119" viewBox="0 0 205 119" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M18.8723 57.131L0.0751953 87.2059V118.005H204.36V0.967072L183.081 64.378L167.83 31.7666L158.609 52.4205L142.295 20.5339L120.66 104.236L101.863 42.6371L86.6127 57.131L72.0715 34.6654L43.3439 99.1634L18.8723 57.131Z" fill="url(#paint0_linear)" />
																<defs>
																	<linearGradient id="paint0_linear" x1="102.218" y1="37.2019" x2="102.218" y2="144.457" gradientUnits="userSpaceOnUse">
																		<stop stop-color="#b0bec5" />
																		<stop offset="1" stop-color="#eceff1" stop-opacity="0" />
																	</linearGradient>
																</defs>
															</svg>
														</div>
													</div>
													<div className="box interviewBg w-100">
														<div className="info">
															<div className="row mb-46">
																<div className="col-12 p-0">
																	<h1> {allInterviews.length} </h1>
																	{translations.Interviews}
																</div>
															</div>
															<div className="row usersStatus">
																<div className="col-md-6 col-sm-6 col-6 p-0">
																	<h4 className="pb-0"> {values.allCompletedInterviews} </h4>
																	{translations.Done}
																</div>
																<div className="col-md-6 col-sm-6 col-6 p-0">
																	<h4 className="pb-0 unverified">  {values.allPendingInterviews} </h4>
																	{translations.Pending}
																</div>
															</div>
														</div>
														<div className="infoGraph">
															<h1> {values.filteredInterviews} </h1>
															{translations.New_Interviews}
															<svg width="206" height="119" viewBox="0 0 206 119" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M18.9549 57.5483L0 87.9084V119H206V0.851852L184.542 64.864L169.163 31.9435L159.865 52.7931L143.413 20.6042L121.597 105.1L102.642 42.917L87.2639 57.5483L72.6007 34.8697L43.6319 99.9792L18.9549 57.5483Z" fill="url(#paint0_linear)" />
																<defs>
																	<linearGradient id="paint0_linear1" x1="103" y1="37.4302" x2="103" y2="145.702" gradientUnits="userSpaceOnUse">
																		<stop stop-color="#FFDB7E" />
																		<stop offset="1" stop-color="#FFD159" stop-opacity="0" />
																	</linearGradient>
																</defs>
															</svg>
														</div>
													</div>
												</div>
												<div className="righSide">
													<div className="interviewStatusGraph">
														<div>
															<Bar
																data={values.completePerData}
																ref={(node) => createChartRef(node)}
																width={100}
																height={320}
																options={{
																	responsive: true,
																	maintainAspectRatio: false,
																	tooltips: {
																		mode: "x",
																		callbacks: {
																			title: function (tooltipItem, data) {
																				return data['dates'][tooltipItem[0].index];
																			},
																		}
																	},
																	legend: {
																		display: true, position: 'bottom',
																		labels: {
																			generateLabels: function (chart) {
																				return [
																					{
																						text: 'Completed',
																						fillStyle: '#16ABFF'
																					},
																					{
																						text: 'Pending',
																						fillStyle: '#FF8A58'
																					}
																				]
																			}
																		}
																	},
																	scales: {
																		yAxes: [{ ticks: { fontSize: 12, fontFamily: "Gilroy-Regular", fontColor: '#BBBBBB', fontStyle: '500' }, stacked: true }],
																		xAxes: [{
																			ticks: { fontSize: 12, fontFamily: "Gilroy-Regular", fontColor: '#BBBBBB', fontStyle: '500' }, gridLines: {
																				display: true
																			},
																			stacked: true
																		}]
																	}

																}}
															/>
														</div>
														<div className="text-right analytics">
															<select onChange={(e) => selectInterview(e.target.value)} className="btn btn-outline1">
																<option value="all">All</option>
																{availInterviews.map(intev => {
																	return (
																		<option value={intev.filename}>{intev.title}</option>
																	)
																})}
															</select>&nbsp;&nbsp;&nbsp;
															<a href="javascript:void(0)" onClick={() => exportData()} className="btn btn-outline1">{translations.Export_CSV}</a>
															&nbsp;&nbsp;&nbsp;
															<a className="btn btn-outline1" target="_blank" href="/analytics">{translations.Analytics} &nbsp;<img src={analytics_} /></a>
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												<div className="topInterview mt-lg-0 mt-3 mt-md-3 mt-sm-33">
													<div className="availableInterviews h-100">
														<h1 className="h4">{translations.Top_Interviews}</h1>
														<div className="fixedHeight mt-22">
															{
																availInterviews.map(function (result, index) {
																	return (
																		<div key={index} className="common">
																			<div className="row">
																				<div className="col-md-12 p-0">
																					<strong>{result.metadata.title}</strong>
																					<div>{result.metadata.comment}</div>
																				</div>
																			</div>
																			<div className="mb-3"></div>
																		</div>
																	);
																})
															}
														</div>
													</div>
												</div>
												<div className="pieChart">
													<div className=" interviewStatus">
														<Pie data={values.interviewStatus} width={200}
															height={150} redraw />
													</div>
												</div>
											</div>
										</section>
									</div>
								</Container>
							</div>
						</div>
						<Footer />
					</div>
				</>
			)}
		/>
	);
};


